import { createListenerMiddleware } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "./redux-store";

// RTK's listener middleware: lets a reaction to one action wait for some
// other state (e.g. features being loaded) before it dispatches anything.
// Kept in its own module so ducks can register listeners without importing
// the store itself.
export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch
>();
